var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApproval2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 326,
    viewBox: "0 0 247 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_9060)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.717 173.244L227.662 124.15C228.399 120.512 226.269 116.902 222.745 115.841C212.535 112.767 191.46 107.995 173.323 113.977C148.317 122.225 158.587 169.883 158.587 169.883L217.717 173.244Z",
    fill: "#EF5489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.871 50.5979L163.158 64.6215L156.106 77.2969C148.858 103.189 139.336 115.239 172.336 115.239C189.556 115.239 197.706 93.6404 174.158 72.7893C173.57 72.2693 181.513 66.9887 176.871 50.5979",
    fill: "#774331"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.43 121.025C195.169 99.9576 183.782 91.2951 170.174 88.4398L169.279 69.3562L156.309 74.0098L155.415 88.4398C141.807 91.2951 128.862 103.298 124.887 121.436L201.43 121.025Z",
    fill: "#B26E4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4265_9060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 31,
    width: 30,
    height: 26
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.146 31H163.182V56.1822H134.146V31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4265_9060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.115 39.3424C155.338 38.8559 146.835 24.7874 136.957 34.2852C128.738 42.189 141.16 56.1822 141.16 56.1822C141.16 56.1822 168.892 39.8289 162.115 39.3424",
    fill: "#774331"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.384 62.2266C168.384 73.993 161.745 83.5318 154.325 83.5318C146.905 83.5318 140.266 73.993 140.266 62.2266C140.266 50.4601 144.561 44.0776 153.934 44.0776C163.307 44.0776 168.384 50.4601 168.384 62.2266",
    fill: "#B26E4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.959 69.7509C150.918 69.7509 150.876 69.7442 150.835 69.7304C150.752 69.7024 148.789 69.0277 148.096 67.6283C147.437 66.2955 149.003 59.7643 149.323 58.4686C149.376 58.2576 149.589 58.1289 149.797 58.1818C150.006 58.2347 150.133 58.4489 150.081 58.6604C149.313 61.7646 148.406 66.4897 148.795 67.2752C149.251 68.1972 150.601 68.8198 151.082 68.982C151.287 69.051 151.398 69.2743 151.329 69.4811C151.275 69.6464 151.122 69.7509 150.959 69.7509",
    fill: "#7F402C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.834 43.8984C148.834 43.8984 155.737 66.9889 172.139 73.6962C172.139 73.6962 183.018 63.2838 179.603 49.809C176.189 36.3339 165.033 39.2688 157.909 38.389C150.785 37.5092 151.076 34.0936 148.834 43.8984",
    fill: "#774331"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.667 81.5805L154.574 80.4008C169.903 79.1686 171.061 69.2735 171.138 67.3024C171.141 67.2294 171.148 67.188 171.15 67.1777L171.726 67.285L172.31 67.3257C172.276 68.2043 172.002 71.2332 169.873 74.2901C166.904 78.5555 161.788 81.0084 154.667 81.5805",
    fill: "#103541"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.076 63.1875C178.973 65.928 177.502 68.8855 174.79 69.7926C172.077 70.6996 169.15 69.2134 168.252 66.4729C167.354 63.732 168.825 60.7749 171.538 59.8679C174.251 58.9604 177.178 60.4471 178.076 63.1875",
    fill: "#103541"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.536 62.1946C176.006 51.3277 172.151 41.5348 165.891 38.582C163.575 38.1457 161.701 38.7103 159.355 38.5303C166.281 39.7657 170.577 50.4183 170.069 62.1946H175.536Z",
    fill: "#103541"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.68 82.0322L154.832 82.0492C154.121 82.0555 153.534 81.4727 153.527 80.7539C153.521 80.0354 154.098 79.442 154.809 79.4357L156.657 79.4188C157.368 79.4121 157.956 79.9948 157.962 80.7136V80.7136C157.968 81.4325 157.392 82.0259 156.68 82.0322",
    fill: "#103541"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.43 121.025C195.201 100.067 183.899 91.3877 170.385 88.4871C170.384 88.4886 170.383 88.4898 170.383 88.4914C168.04 95.1986 163.371 98.3549 159.058 98.3549C154.772 98.3549 152.452 94.0714 154.719 88.5999C141.289 91.7113 128.013 103.606 124.106 121.436C124.106 121.436 120.786 150.434 98.9167 150.04L98.498 161.781L152.327 166.254H158.373C219.727 181.44 201.43 121.025 201.43 121.025",
    fill: "#10BEF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.521 118.009C153.917 106.477 163.566 95.9959 171.569 88.7572C171.106 88.6452 170.641 88.5383 170.172 88.4396L170.159 88.2246C162.569 94.978 153.806 104.274 149.718 114.036C150.7 106.017 153.15 95.453 154.875 88.5643C154.445 88.6622 154.015 88.7695 153.587 88.8855C151.514 97.2225 148.532 110.372 148.154 118.375L149.521 118.009Z",
    fill: "#103540"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.279 116.776C150.001 117.261 149.73 117.746 149.469 118.229L147.959 121.025L148.002 117.841C148.009 117.314 148.02 116.789 148.033 116.266L150.279 116.776Z",
    fill: "#6A707A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.642 134.877H145.013C144.357 134.877 143.82 134.335 143.82 133.673V120.695C143.82 120.032 144.357 119.49 145.013 119.49H151.642C152.298 119.49 152.834 120.032 152.834 120.695V133.673C152.834 134.335 152.298 134.877 151.642 134.877",
    fill: "#F4F8FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4265_9060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 31,
    width: 223,
    height: 296
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 326.4H235.6V31H13V326.4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4265_9060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.984 126.986H150.671V121.851H145.984V126.986Z",
    fill: "#F69159"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.267 135.671C110.199 135.425 107.042 136.629 104.965 138.837C103.554 140.337 102.641 142.265 102.34 144.275C101.963 146.78 102.588 149.491 104.343 151.362C106.011 153.139 108.64 154.014 111.079 153.603C113.518 153.192 115.69 151.508 116.644 149.289C116.923 148.641 117.074 147.475 117.074 147.475C117.322 147.469 118.477 147.898 118.717 147.958C120.405 148.383 122.033 146.727 122.203 145.041C122.691 140.18 117.929 136.043 113.267 135.671",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2051 157.931L109.588 167.376L113.553 277.645H17.2051V157.931Z",
    fill: "#103540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.04 188.311C91.959 189.222 82.586 195.082 76.1837 200.18C70.9182 204.373 68.8223 211.449 70.9803 217.862L92.9095 276.503C94.7634 282.194 92.0266 288.381 86.5865 290.767C85.2099 291.372 83.6861 292.055 81.8854 292.894L112.505 301.741L112.382 265.733L102.04 188.311Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.259 294.837C95.2554 294.837 89.5881 293.69 84.5843 291.657C83.7513 292.032 82.8601 292.439 81.8853 292.894L69.9852 298.434C69.1717 298.813 68.6504 299.635 68.6504 300.541V301.741H112.505L112.477 293.446C108.941 294.348 105.172 294.837 101.259 294.837",
    fill: "#103541"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9803 217.862L80.0073 242.001C84.8385 243.503 90.0911 244.335 95.5909 244.335C98.7991 244.335 101.923 244.053 104.93 243.522L104.812 188.287L102.04 188.311C91.959 189.222 82.586 195.082 76.1833 200.18C70.9182 204.373 68.8223 211.449 70.9803 217.862",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7302 155.169H13V274.715L17.2044 277.25V164.441L103.693 179.701V321.51L111.803 326.4H235.6V167.794L89.7302 155.169Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.527 148.376V161.458H142.082C141.927 160.85 141.859 160.11 141.859 159.2C141.859 153.963 151.199 148.362 159.963 148.362C160.519 148.362 161.039 148.367 161.527 148.376",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8282 118.216C29.3013 117.821 28.1804 111.825 27.9219 110.509C27.4474 108.09 27.9059 104.307 26.8503 102.233C25.3796 102.814 24.4619 106.583 24.1494 108.112C23.9827 108.929 23.9042 109.776 23.9315 110.615C21.8442 109.133 18.7508 108.159 17.2309 107.98C17.3925 109.563 18.2767 110.969 19.2019 112.258C19.7619 113.037 20.4621 113.929 21.2966 114.576C18.486 115.662 14.0926 118.163 16.7497 118.642C18.2177 118.906 22.8947 117.848 24.5333 117.608C28.0356 117.096 30.6279 118.164 30.8282 118.216",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1392 130.007C39.7561 127.851 39.3617 125.66 38.3779 123.708C36.8393 120.655 33.842 118.396 30.5065 117.775L25.7577 117.237C27.6018 118.659 29.4458 120.081 31.2895 121.504C31.8886 121.965 32.4915 122.435 33.0543 122.942C31.7105 122.945 30.3198 123.119 29.1127 123.247C27.3432 123.434 25.5593 123.761 23.9667 124.562C22.0805 125.512 20.5641 127.076 19.2668 128.754C17.1661 131.47 15.5427 134.561 14.4941 137.842C18.2018 134.907 22.885 133.253 27.5947 133.214C30.84 133.188 34.5098 133.773 36.9642 131.629C36.9685 131.625 36.9721 131.621 36.9764 131.617C38.5607 137.001 40.1416 150.632 43.2049 147.257C42.1828 141.507 41.1612 135.757 40.1392 130.007",
    fill: "#48C1BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4205 145.455C45.8528 139.562 47.1388 133.735 49.225 128.215C49.6377 127.122 50.0939 126.021 50.8488 125.135C52.5226 123.169 55.2633 122.648 57.6732 121.756C60.7728 120.609 63.5381 118.62 65.7079 116.114C67.354 114.214 70.5399 109.938 69.9756 107.317C67.0419 107.952 63.7252 109.084 60.747 109.937C57.8857 110.756 55.5538 112.221 53.6094 114.137C54.378 111.19 54.7146 108.127 54.5779 105.084C54.54 104.239 54.6927 101.207 53.691 100.935C52.6186 100.643 51.3568 103.549 50.9909 104.225C49.4343 107.095 48.3482 110.244 47.8952 113.489C47.6422 115.299 47.5851 117.139 47.7644 118.96C47.7972 119.292 48.158 120.573 48.4759 121.777C48.3131 122.127 48.1537 122.481 47.9991 122.839C46.3163 126.738 44.9862 131.082 44.2485 135.446C44.1473 132.587 44.2133 129.729 44.55 126.887C44.978 123.278 45.8407 119.702 45.8047 116.067C45.7485 110.36 43.2644 104.779 39.2806 100.766C37.9907 99.4671 34.2135 95.6144 33.1236 97.8143C32.5354 99.0011 33.2634 102.235 33.368 103.571C33.518 105.487 33.7515 107.397 34.1545 109.276C35.0313 113.362 36.7562 117.364 39.6996 120.303C40.494 121.097 41.3969 121.844 41.8264 122.886C42.1268 123.615 42.1654 124.422 42.2002 125.211C42.5067 132.15 42.8133 139.09 43.1195 146.031C43.781 146.287 44.5355 146.29 45.1994 146.04C45.176 145.856 45.1537 145.673 45.1311 145.489C45.2275 145.49 45.3244 145.483 45.4205 145.455",
    fill: "#48C1BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9662 122.73C62.2638 122.11 59.2763 121.939 56.8663 123.322C54.2209 124.839 52.8544 127.857 51.654 130.681C50.0309 134.501 48.4079 138.32 46.7849 142.139C46.4545 142.916 46.1179 143.723 46.1292 144.569C46.153 146.362 47.9627 147.243 49.246 145.912C50.1707 144.952 50.2844 142.504 50.6476 141.277C51.9301 136.947 53.5976 132.734 55.6268 128.705C58.5608 130.326 62.0256 131.081 65.3087 130.438C68.5915 129.796 71.6372 127.661 73.0587 124.603C70.2961 124.381 67.6687 123.351 64.9662 122.73",
    fill: "#48C1BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9447 111.651C54.0193 109.668 59.384 107.387 60.5594 106.871C62.7191 105.923 66.3279 105.954 68.0552 104.323C67.2324 102.551 63.5481 101.939 62.0653 101.766C61.2733 101.674 60.4696 101.698 59.694 101.854C60.6723 99.0067 60.9843 94.9646 60.8598 93.0215C59.4172 93.4543 58.2788 94.7728 57.2572 96.1261C56.639 96.9452 55.9438 97.9572 55.5021 99.1033C53.9514 95.7158 50.7803 90.5366 50.8447 93.9569C50.8803 95.8468 52.7634 101.592 53.3011 103.624C54.4508 107.967 53.9545 111.391 53.9447 111.651",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8201 135.213C43.9028 134.257 45.2954 130.571 45.5926 129.755C46.139 128.257 47.8268 126.504 47.8448 124.901C46.6131 124.483 44.6108 126.004 43.8403 126.65C43.4287 126.996 43.0675 127.401 42.7828 127.853C41.8697 126.054 40.0741 124.026 39.0833 123.187C38.6221 124.094 38.7272 125.263 38.9033 126.391C39.0099 127.074 39.1731 127.884 39.5188 128.632C37.1736 127.821 33.2168 126.973 34.8887 128.527C35.8123 129.386 39.4434 131.127 40.6685 131.806C43.2862 133.257 44.6999 135.087 44.8201 135.213",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5203 142.603H37.4662C35.7003 142.603 33.9441 142.372 32.2414 141.917C31.4338 141.701 30.6465 142.328 30.6465 143.172V156.841C30.6465 158.034 31.4475 159.083 32.594 159.367C34.1862 159.762 35.8221 159.963 37.4662 159.963H52.5203C54.1644 159.963 55.8003 159.762 57.3925 159.367C58.539 159.083 59.34 158.034 59.34 156.841V143.172C59.34 142.328 58.5527 141.701 57.7451 141.917C56.0424 142.372 54.2862 142.603 52.5203 142.603",
    fill: "#F15961"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.095 155.934H80.8633C81.5986 157.422 83.0104 158.46 84.6553 158.682L122.59 163.792C122.756 163.814 122.923 163.825 123.09 163.825H152.128C153.962 163.825 155.448 162.324 155.448 160.472L102.095 155.934Z",
    fill: "#F4F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.984 150.196L122.081 97.1151C121.722 95.1893 120.098 93.7662 118.16 93.6794L60.016 91.0758C57.2913 90.9535 55.1833 93.4585 55.7402 96.1556L65.6236 144.005C65.9856 145.759 67.404 147.091 69.1618 147.328L78.065 148.527L71.2401 159.628L99.0851 164.17L105.444 152.215L127.326 155.162C130.148 155.543 132.511 153.022 131.984 150.196",
    fill: "#D8E5E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_9060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval2);
export default __webpack_public_path__ + "static/media/PendingApproval2.0db405ff12b1e79ef79192946cd7d086.svg";
export { ForwardRef as ReactComponent };